export default "__VITE_ASSET__BJKs$5Ro__"